import leonsbuLogo from './img/leonsbuLogo.png';
import 'animate.css'
import './styles/App.css';
import { SocialCardItem } from './components/SocialCardItem';
import { NavButton } from './components/NavButton';
import { CreditsButton } from './components/CreditsButton';
import FanArtCarousel from './components/FanArtCarousel';

import {useState, useEffect} from "react";

function SecondaryRowDesktop () {
    return (
        <div className='infobox-3b-subpages'>
            <SocialCardItem
                type='secondary'
                social='youtube-etc'
                title='LeonETC'
                url='https://www.youtube.com/@LeonETC/'
            />
            <SocialCardItem
                type='secondary'
                social='discord'
                title='Discord'
                url='https://discord.gg/9DvCWs8Z3G'
            />
            <SocialCardItem
                type='secondary'
                social='bluesky'
                title=''
                url='https://bsky.app/profile/leonsbu.bsky.social'
            />
            <SocialCardItem
                type='secondary'
                social='twitter'
                title=''
                url='https://x.com/leonsbu_/'
            />
            <SocialCardItem
                type='secondary'
                social='merch'
                title=''
                url='https://leonsbu-shop.fourthwall.com/'
            />
            <SocialCardItem
                type='secondary'
                social='tiktok'
                title=''
                url='https://www.tiktok.com/@leon.sbu/'
            />
        </div>
    )
}

function SecondaryRowMobileTop () {
    return (
        <div className='mobile-secondary-subbox'>
            <SocialCardItem
                type='secondary'
                social='youtube-etc'
                title='LeonETC'
                screenWidth={599}
                url='https://www.youtube.com/@LeonETC/'
            />
            <SocialCardItem
                type='secondary'
                social='discord'
                title='Discord'
                screenWidth={599}
                url='https://discord.gg/9DvCWs8Z3G'
            />
            <SocialCardItem
                type='secondary'
                social='bluesky'
                title=''
                screenWidth={599}
                url='https://bsky.app/profile/leonsbu.bsky.social'
            />
        </div>
    )
}

function SecondaryRowMobileBottom () {
    return (
        <div className='mobile-secondary-subbox'>
            <SocialCardItem
                type='secondary'
                social='twitter'
                title=''
                screenWidth={599}
                url='https://x.com/leonsbu_/'
            />
            <SocialCardItem
                type='secondary'
                social='merch'
                title=''
                screenWidth={599}
                url='https://leonsbu-shop.fourthwall.com/'
            />
            <SocialCardItem
                type='secondary'
                social='tiktok'
                title=''
                screenWidth={599}
                url='https://www.tiktok.com/@leon.sbu/'
            />
        </div>
    )
}

function SecondaryRowMobile () {
    return (
        <div className='infobox-mobile-secondary'>
            <SecondaryRowMobileTop />
            <SecondaryRowMobileBottom />
        </div>
    )
}

export function Home ({ youtubeSubCount, twitchFollowCount }) {

    const [windowWidth, setWindowWidth] = useState(1920)

    useEffect(() => {
    const detectScreenType = () => {
      setWindowWidth(window.innerWidth)
    };

    window.addEventListener("resize", detectScreenType)
    detectScreenType()
    return () => window.removeEventListener("resize", detectScreenType);
    }, []);

    return (
        <div className='App'>
            <img src={leonsbuLogo} className='leonsbu-logo' alt='leonsbu logo' />
            <div className='infobox-1-outer'>
                <div className='infobox-2a-profile'>
                    <div className='infobox-credits'>
                        <CreditsButton />
                    </div>
                        <div className='fan-art-carousel'>
                            <FanArtCarousel
                                baseWidth={windowWidth > 600 ? 350 : windowWidth / 2}
                                autoplay
                                autoplayDelay={2000}
                                pauseOnHover
                                loop={true}
                            />
                        </div>
                </div>
                <div className='infobox-2b-socials'>
                    <div className='infobox-3a-mainpages'>
                        <SocialCardItem
                            type='main'
                            social='youtube'
                            title='LeonSBU'
                            subtitle={`${youtubeSubCount}K✓`}
                            url='https://www.youtube.com/@LeonSBU/'
                        />
                        <SocialCardItem
                            type='main'
                            social='twitch'
                            title='LeonSBU_'
                            subtitle={`${twitchFollowCount}K✓`}
                            url='https://www.twitch.tv/leonsbu_/'
                        />
                        </div>
                        {windowWidth > 600 ? <SecondaryRowDesktop /> : <SecondaryRowMobile />}
                        <div className='infobox-3d-bottom'>
                            <NavButton
                                type='tertiary'
                                title='More About Me'
                                path='about'
                            />
                            <NavButton
                                type='tertiary'
                                title='🧡 Support My Work! 🧡'
                                path='support'
                            />
                            <NavButton
                                type='tertiary'
                                title='Business Inquiries'
                                path='business'
                            />
                    </div>
                </div>
            </div>
        </div>
    )
}